import axios from 'axios';
import { ltiBaseUrl } from '../services';
import { getLtiToken } from '../util';

const ltiInstance = axios.create({ baseURL: ltiBaseUrl });

ltiInstance.interceptors.request.use((config) => {
  const token = getLtiToken();
  if (!token) {
    return Promise.reject(new Error('No LTI token — relaunch from Canvas'));
  }
  config.headers = {
    'Content-Type': 'application/json',
    LtiAuthorization: token,
  };
  return config;
});

ltiInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.code === 'ERR_NETWORK') {
      error.response = { data: { timeout: true } };
    }
    return Promise.reject(error.response?.data);
  },
);

export default ltiInstance;
